import { render, staticRenderFns } from "./NewDuty.vue?vue&type=template&id=0f4479d7&scoped=true&"
import script from "./NewDuty.vue?vue&type=script&lang=js&"
export * from "./NewDuty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4479d7",
  null
  
)

export default component.exports